import { AsyncPipe } from '@angular/common';
import { Component, inject, Input } from '@angular/core';

import { ToastService } from '@services/components/ToastService/toast.service';
import { ToastPosition } from '@services/components/ToastService/toast.types';

import { ToastComponent } from './toast.component';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [AsyncPipe, ToastComponent],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.css',
  host: {
    '[attr.data-position]': 'position',
  },
})
export class ToastContainerComponent {
  @Input() position: ToastPosition = 'bottom-right';

  protected readonly toastService = inject(ToastService);
  protected readonly toasts$ = this.toastService.toasts$;
}
